import { Flex, Text } from '@chakra-ui/react';
import { Avatar } from 'ui-components/dist/Avatar';
import { ContentCardPlatformIcon } from '~/components/ContentCard/components';
import { IconBox } from '~/components/IconBox';
import { ALL_SOCIAL_PLATFORM_TYPE } from '~/constants';
import { formatAbbr } from '~/utils';

interface Props {
  platform: string;
  avatar: string;
  name: string;
  handle: string;
  followers: number;
}

export const PlatformInfo: React.FC<Props> = ({
  platform,
  avatar,
  name,
  handle,
  followers,
}) => (
  <Flex alignItems="center" gap={2}>
    <IconBox
      icon={
        <ContentCardPlatformIcon
          width={5}
          height={5}
          platform={platform as ALL_SOCIAL_PLATFORM_TYPE}
        />
      }
      width={6}
      height={6}
    />
    <Avatar src={avatar} name={''} alt={''} />
    <Flex flexDirection="column" alignItems="flex-start">
      <Text color="primary.700" fontSize="2xl" lineHeight={4} fontWeight={500}>
        {name}
      </Text>
      <Flex alignItems="center" justifyContent="center" gap={1}>
        <Text
          color="primary.300"
          fontSize="md"
          lineHeight="14px"
          fontWeight={400}
        >
          @{handle}
        </Text>
        &middot;
        <Text
          color="primary.700"
          fontSize="md"
          lineHeight="16px"
          fontWeight={400}
        >
          {formatAbbr(followers)}
        </Text>
      </Flex>
    </Flex>
  </Flex>
);
